import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/shareIcons/pencil_fill.svg'


const _hoisted_1 = { class: "row" }

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import docLuBillCustomActAdd from './docLuBillCustomActAdd.vue';
import docLuBillCustomActEdit from './docLuBillCustomActEdit.vue'
import { useAppUserStore } from '@/stores/appUser';


export default /*@__PURE__*/_defineComponent({
  __name: 'docLuBillCustomActsSettings',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const appUserStore = useAppUserStore();

const dropd = ref("");
const emits = __emit;
const customActs = computed(() => {
  if (!appUserStore.currentAppUserData) return null;
  return appUserStore.currentAppUserData.preferences.luActsCustom;
})

function closeModal(){
  emits('close')
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"margin":"1rem"},
    class: "bg-modal w-maxC",
    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.document.luBillAddon.personalActs'),
        class: "cursor-sel",
        styles: "font-l"
      }, null, 8, ["txt"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
        openOn: "CustomActAdd"
      }, {
        dropd: _withCtx(() => [
          _createVNode(docLuBillCustomActAdd, {
            onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_buttonGroup, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
            openOn: "CustomActAdd",
            class: "mleft-04"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "plus",
                styles: "main-m size-l"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_dbGroup, { class: "mtop-06" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customActs.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_dropdownBox, {
            key: index,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
            openOn: 'customActEdit' + item.appUserLuActId
          }, {
            dropd: _withCtx(() => [
              _createVNode(docLuBillCustomActEdit, {
                appUserLuAct: item,
                onClose: _cache[3] || (_cache[3] = ($event: any) => (closeModal()))
              }, null, 8, ["appUserLuAct"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_list_group, {
                styles: "pad-0",
                class: "psides-04"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: item.description
                  }, null, 8, ["txt"]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mleft-04" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "img-grey"
                    })
                  ], -1))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["modelValue", "openOn"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})